import { render, staticRenderFns } from "./deviceWiseAlerts.vue?vue&type=template&id=537dd0e8&"
import script from "./deviceWiseAlerts.vue?vue&type=script&lang=js&"
export * from "./deviceWiseAlerts.vue?vue&type=script&lang=js&"
import style0 from "./deviceWiseAlerts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports